export default __webpack_public_path__ + "static/media/icon-imc.968a3379.svg";